import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";
const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function IntroductionPage() {
  return (
    <ContentOverlay
      heading={
        <h3
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
            color: "black",
          }}
        >
          {" "}
          <b>Introduction</b>
        </h3>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              It has been witnessed since the beginning of history, that humans
              have a tendency to prove themselves to be superior to all other
              living organisms. It is now truthful to state that there exists an
              ego among the human breed to dominate the available resources for
              their immediate benefits. Previously, this was just altering the
              local climate which was almost negligible as nature has a
              self-cleansing and maintaining property, but from past few
              decades, due to extreme pressure on nature, the climate across the
              globe is being affected due to anthropogenic activities.
              Initially, climate change was considered essential only on
              academic basis, but over the past few years, due to increased
              awareness among people, it has become one of the most concerned
              and researched topics, also being one of the most significant
              developmental challenges for humans (
              <a href="#_bookmark47">Lal, 2017</a>). One of the most critical
              factors of changing climate can be inferred as unplanned and
              hap-hazardous urban areas development. Urbanization has conve-
              niently brought numerous positive changes such as making cities
              economically sustainable, increasing the GDP per capita, providing
              a better standard of living and quality of life, improved medical
              facilities, increased occupational opportunities, and better
              education (<a href="#_bookmark44">Keeling, 1997</a>;{" "}
              <a href="#_bookmark43">Karoly et al.,</a>{" "}
              <a href="#_bookmark43">2003</a>;{" "}
              <a href="#_bookmark82">Stott et al., 2006</a>). However, due to
              increased demographic pressure on the cities due to large movement
              of population from rural to urban areas, rapid and unorganized
              developments have started to come-up in cities for satisfying the
              needs of incoming residents. These changes gradually collapse the
              balance, creating problems such as unavailability of basic
              housing, lack of fresh and treated water supply, inadequate
              infrastructure, and rise in greenhouse gases as well as pollution
              levels (<a href="#_bookmark69">Ramachandra et al., 2012</a>).
              Scientific communications have found that these alterations in
              urban areas can be understood by deriving land use/land cover
              maps, and these maps can be used to demonstrate the phenomenon of
              urbanization. These changes in LULC includes the development of
              urban pockets (pervious surface) on the cost of areas that serves
              important feeders for human life such as vegetation, open/bare
              fields, agricultural fields, etc. (
              <a href="#_bookmark42">Kandlikar and Sagar, 1999</a>;{" "}
              <a href="#_bookmark51">Mallick et al., 2008</a>;{" "}
              <a href="#_bookmark70">Ramachandra et al., 2016</a>). In
              today&rsquo;s scenario, there have been numerous cases where urban
              areas have come-up by encroaching water bodies such as lakes,
              ponds, and catchment areas, leading to a rise in urban floods.
              These unprecedented alterations in LULC affect evapotranspiration
              rates, surface albedo, storage of heat and moisture content of the
              surfaces, pollution displacement, and surface temperature (
              <a href="#_bookmark66">Pal and Ziaul, 2017</a>). Due to such
              changes, the phenomenon of global warming has been intensifying
              over the years, and it creates a massive threat for sensitive
              species in nature as most of the flora and fauna are sensitive to
              temperature.
            </p>
            <p>
              Researchers across the globe have found a strong relationship
              between alteration in LULC and climate change in terms of Land
              Surface Temperature (LST) (
              <a href="#_bookmark25">Aggarwal et al., 2012</a>;{" "}
              <a href="#_bookmark60">Mutiibwa et al.,</a>{" "}
              <a href="#_bookmark60">2014</a>). LST is an important parameter
              that accounts for the upward thermal radiation and can be defined
              as the radiative skin temperature of the earth&rsquo;s surface. It
              is a crucial parameter to describe the thermal comfortability of
              the residents (<a href="#_bookmark27">Bento et al., 2017</a>). LST
              not only affects human but also disturbs rainfall patterns, wind
              turbulence and speed, crop patterns, ecology of the region, and
              earth&rsquo;s natural cycles including biogeochemical cycle, water
              cycle, and carbon cycle. It is one of the key input parameters in
              numerous applications such as urban climatology, greenhouse gas
              quantification, crop monitoring, studies related to global warming
              and also defines the phenomena of Urban Heat Island (UHI) (
              <a href="#_bookmark76">Schmugge and Becker, 1991</a>;{" "}
              <a href="#_bookmark48">Li and Becker, 1993</a>;{" "}
              <a href="#_bookmark73">Running et al., 1994</a>;{" "}
              <a href="#_bookmark26">Anderson et al., 2008</a>;{" "}
              <a href="#_bookmark49">Li et al., 2013</a>;{" "}
              <a href="#_bookmark71">Ramachandra et al., 2017</a>;{" "}
              <a href="#_bookmark45">Khandelwal et al., 2018</a>). UHI is a
              phenomenon that is being observed in many cities across the globe
              as a result of higher temperatures in urban areas when compared to
              nearby rural areas due to increased impervious surfaces in urban
              areas. UHI is an issue of serious concern as it is responsible for
              a large number of health-related issues and deaths across the
              globe. Thus, it is a need-of-hour to study the dreadful effects of
              rising LST on the inhabitants and suggest some mitigation
              measures.
            </p>
            <p>
              Remote Sensing (RS) and Geographic Information System (GIS) have
              developed across the years and are now considered as a
              state-of-the-art technology for any climate and urban-related
              studies. Thus, the case study presented in this chapter uses
              remote sensing data and open source GIS software for complete
              analysis. This book chapter deals with the understanding of how
              changes in landscape due to increased anthropogenic activities
              affect climate in terms of land surface temperature. The chapter
              also deals with explaining how a rise in LST causes an increase in
              UHI effect, that further affects the health and welfare of
              inhabitants in an urban area with a case study. Also, few
              mitigation measures were suggested to reduce the overall rise and
              eliminate the ill-effects of LST
            </p>
            
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default IntroductionPage;
